
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Onedaytournearakola() {



  const cardData =
  {
    keyword: ' One Day Tour Near Akola',
    heading:  'Woodland Escape: One Day Tour Near Akola',
    headingDescription: 'Woodland Escape Resort, an ideal destination for a one day tour near Akola, offers the perfect blend of adventure, relaxation, and natural beauty just a short drive from the city. Surrounded by lush forests, green lawns, and tranquil streams, the resort provides an inviting escape for families, friends, and corporate groups looking to unwind in nature. Guests can enjoy a variety of engaging activities such as ziplining, trekking, archery, swimming, and team games, or simply relax in shaded picnic areas and scenic outdoor spaces. With delicious meals, modern amenities, and a peaceful ambiance, Woodland Escape Resort near Akola ensures your one-day tour is filled with fun, comfort, and unforgettable memories amidst nature’s charm.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



 "services": [
    {
      "name": "One Day Tour Near Akola",
      "description": "Woodland Escape Resort offers an ideal one-day tour near Akola, perfect for those seeking a peaceful yet activity-filled escape. Guests can enjoy nature walks, outdoor games, and authentic local meals amidst beautiful countryside scenery. It’s the perfect destination for families, couples, and groups looking to unwind for a day in a relaxing natural setting."
    },
    {
      "name": "Akola Day Trip",
      "description": "Plan a rejuvenating Akola day trip to Woodland Escape Resort, where you can enjoy a full day of fun, food, and relaxation. The resort’s serene surroundings, combined with exciting outdoor activities and lush green landscapes, make it a great choice for a quick and refreshing getaway."
    },
    {
      "name": "Akola Sightseeing Tour",
      "description": "Enhance your Akola sightseeing tour with a visit to Woodland Escape Resort. After exploring local landmarks and attractions, relax in the resort’s tranquil ambiance. Enjoy meals, adventure games, and scenic views, creating a perfect blend of sightseeing and leisure."
    },
    {
      "name": "Akola Short Trip",
      "description": "Woodland Escape Resort is an excellent destination for an Akola short trip. Whether it’s a half-day visit or a full-day adventure, guests can participate in nature-based activities, enjoy farm experiences, and savor delicious meals in a peaceful countryside setting."
    },
    {
      "name": "Affordable One Day Tour Akola",
      "description": "Looking for an affordable one-day tour near Akola? Woodland Escape Resort provides budget-friendly packages that include food, activities, and access to all recreational areas. Guests can enjoy a fulfilling day without spending much, making it a great option for families and groups."
    },
    {
      "name": "Akola Nearby Attractions Tour",
      "description": "Located near Akola’s top attractions, Woodland Escape Resort is a great base for exploring the region. After visiting nearby temples, lakes, or heritage sites, guests can relax at the resort, participate in fun activities, and enjoy the calm natural environment."
    },
    {
      "name": "Akola City Tour",
      "description": "Combine your Akola city tour with a relaxing visit to Woodland Escape Resort. After exploring the city’s cultural spots and markets, unwind with a peaceful meal, refreshing drinks, and outdoor leisure activities at the resort’s lush property."
    },
    {
      "name": "Akola Weekend Day Tour",
      "description": "Woodland Escape Resort is a popular choice for an Akola weekend day tour. Spend your weekend enjoying outdoor games, nature walks, and fresh countryside air, all within a short drive from the city. It’s the ideal way to de-stress and recharge before the new week begins."
    },
    {
      "name": "Akola Family Day Trip",
      "description": "Woodland Escape Resort is perfect for a family day trip near Akola. The resort offers safe play zones for kids, relaxing picnic areas, and adventure activities suitable for all ages. Families can spend quality time together surrounded by greenery and tranquility."
    },
    {
      "name": "Akola Local Tour Packages",
      "description": "Woodland Escape Resort provides customizable Akola local tour packages that include meals, activities, and access to resort amenities. Ideal for school trips, office outings, or family gatherings, these packages ensure a complete and well-organized day of fun."
    },
    {
      "name": "Akola Nature Tour",
      "description": "Experience nature up close with an Akola nature tour at Woodland Escape Resort. Enjoy walking trails, scenic viewpoints, and fresh rural air while observing the beauty of the natural surroundings. It’s a rejuvenating getaway for nature enthusiasts and photographers alike."
    },
    {
      "name": "Akola Hill Tour",
      "description": "Take an Akola hill tour that ends at Woodland Escape Resort, nestled near gentle elevations and scenic landscapes. Guests can enjoy breathtaking views, cool breezes, and outdoor adventures while spending the day in a calm and refreshing atmosphere."
    },
    {
      "name": "Akola Riverside Tour",
      "description": "Woodland Escape Resort offers an enchanting Akola riverside tour experience. Enjoy the soothing sounds of flowing water, indulge in riverside picnics, and relax with family and friends. The natural setting makes it an ideal spot for photography and peaceful moments."
    },
    {
      "name": "Akola One Day Excursion",
      "description": "For a one-day excursion from Akola, Woodland Escape Resort is the perfect destination. Guests can enjoy a full itinerary of outdoor games, team activities, and leisure time surrounded by greenery. The resort combines relaxation and adventure in one memorable day trip."
    },
    {
      "name": "Akola Tour Booking",
      "description": "Book your Akola day tour to Woodland Escape Resort easily with flexible packages. Whether you’re planning a family picnic, a corporate outing, or a quick getaway, the resort’s booking options make it convenient to plan a seamless and enjoyable experience."
    }
  ],
  "tableData": [
    ["- One Day Tour Near Akola", "- Akola Day Trip"],
    ["- Akola Sightseeing Tour", "- Akola Short Trip"],
    ["- Affordable One Day Tour Akola", "- Akola Nearby Attractions Tour"],
    ["- Akola City Tour", "- Akola Weekend Day Tour"],
    ["- Akola Family Day Trip", "- Akola Local Tour Packages"],
    ["- Akola Nature Tour", "- Akola Hill Tour"],
    ["- Akola Riverside Tour", "- Akola One Day Excursion"],
    ["- Akola Tour Booking", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Ideal One Day Tour Near Akola",
    "WhyChoosedescription": "Woodland Escape Resort is the perfect choice for a one‑day tour near Akola, offering a refreshing escape into nature without needing to stay overnight. Tucked in forest surroundings, it invites you to enjoy a full day of relaxation, adventure, and scenic beauty — all within easy reach from Akola."
  },
  {
    "WhyChooseheading": "Serene Forest Setting Just Outside Akola",
    "WhyChoosedescription": "Located near Akola, Woodland Escape Resort is surrounded by dense trees, fresh air, and peaceful landscapes. The natural forest setting creates a calm and rejuvenating environment for your day‑trip, giving you a break from routines and city life."
  },
  {
    "WhyChooseheading": "Comfortable Day‑Use Facilities",
    "WhyChoosedescription": "Even for just one day, comfort matters. Woodland Escape Resort provides well‑designed day‑use spaces — shaded picnic zones, forest‑view sit‑outs, and relaxing resting areas. Whether you’re taking a break between activities or enjoying your lunch in nature, you’ll find it comfortable and inviting."
  },
  {
    "WhyChooseheading": "Activities to Make Your Day Memorable",
    "WhyChoosedescription": "Make the most of your day at Woodland Escape Resort with a mix of fun and relaxation. Go for a nature walk through the forest, explore scenic trails, try light adventure activities or simply lounge by a pond. The resort offers experiences suited for guests of all ages wanting a delightful one‑day outing."
  },
  {
    "WhyChooseheading": "Great for Family, Friends or Group Outings",
    "WhyChoosedescription": "Planning a day out with family, friends or colleagues? Woodland Escape Resort offers the perfect backdrop for group bonding, fun games, and shared memories. Its sprawling forest grounds, safe environment and range of activities make it ideal for groups looking to spend quality time together."
  },
  {
    "WhyChooseheading": "Delicious Meals to Complement Your Day Out",
    "WhyChoosedescription": "Your day gets even better with freshly prepared meals and snacks sourced from the region. At Woodland Escape Resort you’ll find tasty local dishes, picnic‑friendly food options and beverages that add to the joy of your nature getaway — keeping you energised and satisfied throughout your visit."
  },
  {
    "WhyChooseheading": "Convenient Access from Akola",
    "WhyChoosedescription": "Situated conveniently near Akola, Woodland Escape Resort is accessible by road so you can begin your day trip early and return by evening without stress. Its proximity ensures you spend more time enjoying nature and less time travelling."
  }
]









  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort for a one‑day tour near Akola?",
    answer: "Woodland Escape Resort offers a convenient, scenic, and activity‑filled setting close to Akola — ideal for a refreshing one‑day outing with family or friends. You get nature, relaxation and recreation, all in a single package."
  },
  {
    question: "How far is Woodland Escape Resort from Akola?",
    answer: "The resort is located approximately 35‑40 km from Akola, which takes around 1 to 1.5 hours by car. It’s a perfect distance for a day trip without too much travel time."
  },
  {
    question: "What can we do during the one‑day tour at Woodland Escape Resort?",
    answer: "On your one‑day tour you can enjoy nature walks, open‑lawn games, boating/cycling (if available), relaxed picnic meals, and time to unwind in the surroundings. The resort balances fun and calm so you return refreshed."
  },
  {
    question: "Is the one‑day tour suitable for families and groups?",
    answer: "Yes – the resort is family‑friendly with safe outdoor spaces for children, shaded seating for adults, and group‑friendly arrangements. Whether you’re with family, friends or a small group, it works well."
  },
  {
    question: "Are meals included in the one‑day tour package at Woodland Escape Resort?",
    answer: "Yes, the one‑day tour package includes meals — typically welcome drinks, a wholesome lunch and tea/snacks in the evening. You’ll be able to enjoy fresh local food and relax without worrying about logistics."
  },
  {
    question: "How do we book a one‑day tour at Woodland Escape Resort?",
    answer: "Booking is simple – contact our reservation team via phone or WhatsApp, or visit our website to fill in the booking form. We recommend booking in advance, especially for weekends and holiday days, to secure your spot."
  }
];

const testimonials = [
  {
    name: "Mr. Rahul & Family, Akola",
    text: "We had a wonderful one‑day tour at Woodland Escape Resort! The drive was short, the setting peaceful, and the kids had plenty of fun. The food was delicious too. A perfect day trip from Akola."
  },
  {
    name: "Miss. Neha & Friends, Akola",
    text: "Our group visited Woodland Escape Resort for the day and loved every moment! The surroundings were green and refreshing, the activities just right and the staff very accommodating. Highly recommend for a day out near Akola."
  }
];








      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Day Tour Near Akola",
  "image": "https://woodlandescape.com/assets/images/one-day-tour-near-akola.jpg",
  "description": "Plan a memorable one day tour near Akola at Woodlandescape Resort. Enjoy sightseeing, nature walks, outdoor activities, and a relaxing day trip with family and friends in a serene environment.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "854"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1099",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/one-day-tour-near-akola"
  }
};





  return (
    <div>
<Helmet>
  <title>One Day Tour Near Akola | Scenic Day Trip | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Enjoy a perfect one day tour near Akola at Woodlandescape Resort. Explore nature, participate in outdoor activities, and create memorable experiences for families, friends, and couples." 
  />
  <meta 
    name="keywords" 
    content="One Day Tour Near Akola, Akola Day Trip, Akola Sightseeing Tour, Akola Short Trip, Affordable One Day Tour Akola, Akola Nearby Attractions Tour, Akola City Tour, Akola Weekend Day Tour, Akola Family Day Trip, Akola Local Tour Packages, Akola Nature Tour, Akola Hill Tour, Akola Riverside Tour, Akola One Day Excursion, Akola Tour Booking" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/10.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Onedaytournearakola;